import { render } from "./inspectionRecords.vue?vue&type=template&id=79cb50fc&scoped=true"
import script from "./inspectionRecords.vue?vue&type=script&lang=js"
export * from "./inspectionRecords.vue?vue&type=script&lang=js"

import "./inspectionRecords.vue?vue&type=style&index=0&id=79cb50fc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-79cb50fc"

export default script